module.exports = __webpack_public_path__ + "img/page-4.f65fc53a.png";